import {
  Youtube,
  Facebook,
  Twitter,
  Instagram,
  Image as ImageIcon,
  Music,
  Download,
} from "lucide-react";

const MAP = {
  youtube: Youtube,
  facebook: Facebook,
  twitter: Twitter,
  x: Twitter,
  instagram: Instagram,
  image: ImageIcon,
  pinterest: ImageIcon,
  music: Music,
  tiktok: Music,
  download: Download,
};

export default function PlatformIcon({ icon, className, style }) {
  const Cmp = MAP[icon] || Download;
  return <Cmp className={className} style={style} strokeWidth={2} />;
}
